import ChecklistViewColumnsData, {CHECKLIST_VIEW_FILTER_FIELD_CONFIG} from "./checklistViewColumnsData.jsx";
import {PERSISTENCE_STATE_KEYS} from "../PersistenceStateKeys.jsx";
import {
  cellMenuItemCollapseAllRows, cellMenuItemCollapseRow, cellMenuItemNudge,
  cellMenuItemRemoveRow,
  cellMenuItemToggleArchiveRow
} from "../../utils/gridCellMenuUtils.jsx";
import {SWIVU_GROUP_CONTEXT_MENU_SELECTOR} from "../OtherKeys.jsx";

const CHECKLIST_GRID_CONFIG = {
  stateId: PERSISTENCE_STATE_KEYS.checklistView,
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll",
    "swivuChecklistStoreStoreFilter",
    "swivuChecklistStoreStoreSort",
    "swivuChecklistStoreStoreGroup"
  ],
  selectionMode: {
    multiSelect: false,
  },
  cls: 'swivu-checklist-surface',
  rowCopyPasteFeature: false,
  rowReorderFeature: true,
  preserveScrollOnDatasetChange: true,
  filterFeature: {
    pickerConfig: {
      fields: CHECKLIST_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      removeRow: cellMenuItemRemoveRow(),
      archive: cellMenuItemToggleArchiveRow(),
      importChecklistItem: {
        text: "Import Checklist Items",
        icon: "b-fa-solid b-fa-upload",
      },
      exportChecklistItems: {
        text: "Export Checklist Items",
        icon: "b-fa-solid b-fa-download",
      },
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      nudgeUsers: cellMenuItemNudge()
    }
  },
  bbar: {
    hidden: true,
    items: {
      fileFieldImport: {
        type: "filefield",
        accept: "text/plain",
      },
    }
  },
  columns: ChecklistViewColumnsData,
  cellTooltipFeature : {
    hoverDelay: 300,
    textContent: true,
  }
}

export default CHECKLIST_GRID_CONFIG;
